var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarWithGift(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 241.218,
    height: 173.81,
    viewBox: "0 0 241.218 173.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_416",
    "data-name": "Group 416",
    transform: "translate(-977.015 -666.787) rotate(-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_311",
    "data-name": "Path 311",
    d: "M1584.17,710.723q-4.666-.278-9.334-.553a2.127,2.127,0,0,0,.445,2.6l9.333.554q-.223-1.3-.444-2.6",
    transform: "translate(-616.824 167.436)",
    fill: "#474c57",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_312",
    "data-name": "Path 312",
    d: "M1477.8,670.131c.708,3.5,4.177,3.423,6.831,1.927.145-.082.292-.165.435-.242a4.529,4.529,0,0,0,2.232,3.232,3.7,3.7,0,0,0,4.588-.7,5.454,5.454,0,0,0,3.673,1.106,3.583,3.583,0,0,0,3.032-3.288,5.753,5.753,0,0,0-1.619-4.411,2.378,2.378,0,0,0,.172-.239,2.09,2.09,0,0,0-.153-2.629c-.673-.78-2.237-.94-3.3-.845a2.714,2.714,0,0,0,.1-.865c-.077-2.141-2.2-1.713-2.872-.164-.093-.183-.17-.378-.247-.578-.658-1.667-2.23-2.975-3.878-1.624a2.933,2.933,0,0,0-.446.457,5.569,5.569,0,0,0-1.782-.8c-1.537-.388-2.567-.064-3.129.592a3.061,3.061,0,0,0-.286,3.089c-2.25,1.161-3.882,3.362-3.353,5.981",
    transform: "translate(-544.671 204.615)",
    fill: "#e2e7e7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_313",
    "data-name": "Path 313",
    d: "M1563.408,624.731c-1.244,2.811.184,6.16,2.613,6.611,2.707.516,5.3-2.416,5.784-5.612.338-2.175-.233-3.539-1.2-4.2-2.012-1.409-5.8.048-7.2,3.2",
    transform: "translate(-608.162 233.856)",
    fill: "#edd5b9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_314",
    "data-name": "Path 314",
    d: "M1711.167,455.1c-7.616-39.866-29.451-44.721-59.487-46.5-28.188-1.673-48.83-1.19-44.348,40.258-33.436-.165-42.086,29.869-23.678,39.479,12.714.755,23.725,1.423,34.236,2.062l4.094.249c-1.146-4.419-.406-8.844,3.306-10.791,3.86-2.027,9.908-.338,14.154,5.686a14.866,14.866,0,0,1,2.643,6.322l3.9.235c18.629,1.116,39.032,2.3,67.749,3.869-1.278-4.421-.606-8.91,3.2-10.852,3.855-1.97,9.909-.314,14.163,5.571a14.265,14.265,0,0,1,2.678,6.353c17.235.9,34.531,1.751,51.372,2.5,3.7-4.326,5.382-11.1,3.159-18.162-4.049-12.858-16.142-18.319-28.211-21.41-16.308-4.175-37.233-5.4-48.928-4.864",
    transform: "translate(-616.519 392.399)",
    fill: "#ea3a4f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_315",
    "data-name": "Path 315",
    d: "M1779.044,426.907l-.451-.026c-22.021-1.307-41.551-4.235-35.605,35.342l40.381,2.8Z",
    transform: "translate(-741.45 378.9)",
    fill: "#e2e7e7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_316",
    "data-name": "Path 316",
    d: "M1947.7,470.766c-6.961-34.665-22.959-38.874-48.059-41.169l4.326,38.134Z",
    transform: "translate(-858.93 376.406)",
    fill: "#e2e7e7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_317",
    "data-name": "Path 317",
    d: "M2148.969,731.01c-2.56-3.594-5.918-4.586-7.927-3.359-4.9,2.98,1.225,15.424,7.1,13.215,2.991-1.123,3.806-5.672.829-9.856",
    transform: "translate(-1037.397 154.789)",
    fill: "#153939",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_318",
    "data-name": "Path 318",
    d: "M1786.375,707.988c-2.767-4.058-6.506-5.177-8.8-3.792-5.581,3.371.93,17.423,7.585,14.925,3.387-1.268,4.433-6.408,1.214-11.133",
    transform: "translate(-766.443 172.309)",
    fill: "#153939",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_319",
    "data-name": "Path 319",
    d: "M1771.439,436.834c-3.467,1.721-11.87,13.17-12.727,17.4-.475,1.785-.414,3.566.487,4.594a4.812,4.812,0,0,0,.86.825c3.714,2.962,16.954-15.428,16.7-19.946-.215-3.849-2.831-4.106-5.322-2.87",
    transform: "translate(-753.748 371.508)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_320",
    "data-name": "Path 320",
    d: "M1846.831,451.629c-1.224.362-2.956,3.623-2.616,4.957a2.351,2.351,0,0,0,.989,1.535,4.55,4.55,0,0,0,.513.319c2.121,1.19,4.795-4.064,3.923-5.558a2.412,2.412,0,0,0-2.808-1.252",
    transform: "translate(-817.615 360.067)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321",
    "data-name": "Path 321",
    d: "M1579.7,589.927c-2.871.044-6.487,2.135-8.637,5.073a12.913,12.913,0,0,1,3.332,1.48,24.376,24.376,0,0,1,5.305-6.553m131.722,38.88c-1.278-4.42-.606-8.909,3.2-10.851,3.854-1.971,9.907-.314,14.163,5.571a14.272,14.272,0,0,1,2.678,6.352l3.914.2c-6.063-26.512-34.311-23.677-28.044-1.5Zm-91.754-5.321c-1.146-4.419-.407-8.845,3.306-10.791,3.859-2.027,9.908-.338,14.154,5.686a14.887,14.887,0,0,1,2.643,6.323l3.9.234c-6.054-26.849-33.918-24.045-28.1-1.7Zm-3.214-33.119,9.7.743c.187-5.94-9.512-6.149-9.7-.743m158.088,9.249c-3.013,9.24,2.387,18.4,12.441,20.561a21.152,21.152,0,0,0-.991-5.962,26.673,26.673,0,0,0-11.449-14.6",
    transform: "translate(-614.204 259.566)",
    fill: "#153939",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_322",
    "data-name": "Path 322",
    d: "M2382.645,664.47a9.046,9.046,0,0,0,1.9-8.3c-1.184-5.031-5.717-8.529-10.12-7.814a6.83,6.83,0,0,0-2.156.73c.507,6.309,3.074,12.32,10.375,15.388",
    transform: "translate(-1210.942 213.549)",
    fill: "#edd5b9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_323",
    "data-name": "Path 323",
    d: "M1817.688,160.793c1.013,19.95,1.806,39.221,5.059,64.883l23.331.941c4.267-22.61,7.3-43.262,9.812-63.084Z",
    transform: "translate(-797.891 576.611)",
    fill: "#306e57",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_324",
    "data-name": "Path 324",
    d: "M1845.471,167.606c-.11,1.175-.358,2.352-.483,3.481-.507,4.571-.541,9.251-1.011,13.794-.023.226-.047.453-.07.678q3.212.1,6.431.142c.617.008,1.234.011,1.849.016l.165,0c1.32.02,2.64.037,3.962.078-.068.483-.136.971-.2,1.452-3.506-.163-7-.2-10.5-.367q-.914-.039-1.83-.088c-1.125,10.888-2.128,21.939-3.194,32.912-.367,3.832-.572,7.736-.9,11.557l-.989-.041c.382-4.868.625-9.537,1.058-14.564q.438-5.107.858-10.21l.041-.484c.456-5.379.932-10.773,1.49-16.177.106-1.026.218-2.045.328-3.066-7.029-.4-14.045-1.038-21.064-1.833q-.028-.48-.053-.959,10.577,1.191,21.248,1.584c.18-1.719.35-3.441.47-5.2.217-3.129.364-6.255.741-9.371.141-1.146.421-2.275.58-3.414Z",
    transform: "translate(-800.616 571.596)",
    fill: "#ea3a4f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_325",
    "data-name": "Path 325",
    d: "M1876.043,122.214c-2.406,1.994-5.132,4.6-8.379,7.77-.5.5-1.216-.157-.68-.8a78.2,78.2,0,0,1,8.235-7.3c-3.343-1.469-9.217-5.534-11.729-10.884-.487-1.037-.465-1.922.659-1.662,2.295.53,6.577,6.158,11.609,11.28,3.063-6.013,8.273-9.494,12.32-12.119,3.2-2.073,5.985-3.108,6.515-2.265.5.8-1.62,4.092-3.956,6.244a74.942,74.942,0,0,1-13.766,9.607,82.307,82.307,0,0,0,8.072,6.9.53.53,0,0,1,.067.85.81.81,0,0,1-.979-.138c-2.107-1.773-6.587-5.26-7.989-7.489m.127-1.177.5.494c6.183-4.45,15.373-9.567,17.4-15.069-2.65-.031-14.326,7.164-17.9,14.575m-12.3-10.775c1.71,3.9,6.185,8.344,11.091,10.748-5.219-4.758-9.026-9.848-11.091-10.748",
    transform: "translate(-831.779 617.461)",
    fill: "#ea3a4f",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarWithGift);
export default __webpack_public_path__ + "static/media/carWithGift.7dc1c77804f6ce9f6343713c001baa0a.svg";
export { ForwardRef as ReactComponent };